import { createTRPCReact } from '@trpc/react-query';
import { type AppRouter } from 'jigsaw';
import { createTRPCProxyClient, httpBatchLink } from '@trpc/client';
import superjson from 'superjson';

// tRPC for react usage
export const trpcReact = createTRPCReact<AppRouter>();

const batchLink = httpBatchLink({
  // eslint-disable-next-line turbo/no-undeclared-env-vars
  url: `${import.meta.env.VITE_JIGSAW_URL}`,
  /// to support session cookies
  fetch(url, options) {
    return fetch(url, {
      ...options,
      credentials: 'include',
    });
  },
  maxURLLength: 10_000,
});

export const trpcClient = trpcReact.createClient({
  links: [batchLink],
  transformer: superjson,
});

// tRPC for non-react usage
export const trpc = createTRPCProxyClient<AppRouter>({
  links: [batchLink],
  transformer: superjson,
});
